import { useEffect, useRef, useState } from 'react'

export function useIntersectionObserver(options = {}) {
  const elementRef = useRef<HTMLDivElement>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const element = elementRef.current
    if (!element) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.disconnect() // Trigger once
        }
      },
      { threshold: 0.1, ...options },
    )

    observer.observe(element)

    return () => {
      if (element) observer.unobserve(element)
    }
  }, [options])

  return { elementRef, isVisible }
}
